/* eslint-disable camelcase,@typescript-eslint/no-require-imports */
import { Asset } from 'expo-asset';
import { injectable, postConstruct } from 'inversify';
import { computed, observable } from 'mobx';

import { useClassStore } from './useClassStore';

import container from '~ioc/ioc';

// TODO:  adding a new font for loading is a mess right now.
// streamline this so we have one single point of defining endpoints

export enum Assets {
  Font_Gilroy_Light = 'Font_Gilroy_Light',
  Font_Gilroy_Medium = 'Font_Gilroy_Medium',
  Font_Gilroy_SemiBold = 'Font_Gilroy_SemiBold',
  Font_Gilroy_Bold = 'Font_Gilroy_Bold',
  Font_Gilroy_Black = 'Font_Gilroy_Black',
  Image_Shadow = 'Image_Shadow',
  ThreeUpShadow = 'ThreeUpShadow',
}

export const ImportedAssets: Record<Assets, number> = {
  [Assets.Font_Gilroy_Light]: require('../assets/Fonts/Gilroy-Light.ttf'),
  [Assets.Font_Gilroy_Medium]: require('../assets/Fonts/Gilroy-Medium.ttf'),
  [Assets.Font_Gilroy_SemiBold]: require('../assets/Fonts/Gilroy-Semibold.otf'),
  [Assets.Font_Gilroy_Bold]: require('../assets/Fonts/Gilroy-Bold.ttf'),
  [Assets.Font_Gilroy_Black]: require('../assets/Fonts/Gilroy-Black.otf'),
  [Assets.Image_Shadow]: require('../assets/images/merchandiserShadow.png'),
  [Assets.ThreeUpShadow]: require('../assets/images/threeupshadow.png'),
};

@injectable()
class AssetsStore {
  private assets = observable.map<Assets, Asset>();

  get = (asset: Assets): Asset => {
    const found = this.assets.get(asset)!;
    if (!found) {
      throw new Error(`Asset not found: ${asset}`);
    }

    return found;
  };

  @postConstruct() async postConstruct() {
    const [
      Font_Gilroy_Light,
      Font_Gilroy_Medium,
      Font_Gilroy_SemiBold,
      Font_Gilroy_Bold,
      Font_Gilroy_Black,
      Image_Shadow,
      ThreeUpShadow,
    ] = await Asset.loadAsync([
      ImportedAssets[Assets.Font_Gilroy_Light],
      ImportedAssets[Assets.Font_Gilroy_Medium],
      ImportedAssets[Assets.Font_Gilroy_SemiBold],
      ImportedAssets[Assets.Font_Gilroy_Bold],
      ImportedAssets[Assets.Font_Gilroy_Black],
      ImportedAssets[Assets.Image_Shadow],
      ImportedAssets[Assets.ThreeUpShadow],
    ]);

    this.assets.set(Assets.Font_Gilroy_Light, Font_Gilroy_Light);
    this.assets.set(Assets.Font_Gilroy_Medium, Font_Gilroy_Medium);
    this.assets.set(Assets.Font_Gilroy_SemiBold, Font_Gilroy_SemiBold);
    this.assets.set(Assets.Font_Gilroy_Bold, Font_Gilroy_Bold);
    this.assets.set(Assets.Font_Gilroy_Black, Font_Gilroy_Black);
    this.assets.set(Assets.Image_Shadow, Image_Shadow);
    this.assets.set(Assets.ThreeUpShadow, ThreeUpShadow);
  }

  @computed get loaded(): boolean {
    return this.assets.size > 0;
  }
}

export const useAssetsStore = () =>
  useClassStore<AssetsStore>(container.get(AssetsStore));
